import PageSEO from "../shared/PageSEO";
import { createClient, Provider, cacheExchange, fetchExchange } from 'urql';
import { ErrorBoundary } from 'react-error-boundary';
import { ScrollRestoration, Outlet } from 'react-router-dom';
import { Suspense } from 'react';
import PaddedContainer from "../shared/containers/PaddedContainer";
import FeaturedPageSkeleton from "@ashn/workouts-library-react/FeaturedPage/skeleton";
import Box from "@mui/material/Box";

// urql client for workouts library 
const workoutsUrqlClient = createClient({
    url: 'placeholder',
    maskTypename: true,
    exchanges: [cacheExchange, fetchExchange],
});

const fallBack = () => <Box>something went wrong</Box>;

const LearnPage = () => (
    <>
        <PageSEO
            pageTitle="Learn" 
            description="Learn about various topics and resources available."
        />
        <Provider value={workoutsUrqlClient}>
            <ErrorBoundary FallbackComponent={fallBack}>
                <ScrollRestoration />
                <PaddedContainer>
                    <Suspense fallback={<FeaturedPageSkeleton />}>
                        <Outlet />
                    </Suspense>
                </PaddedContainer>
            </ErrorBoundary>
        </Provider>
    </>
);

export default LearnPage;